import styled from "styled-components";

export const AddProductContainer = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  padding-top: 50px;

  h1 {
    margin: 30px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 200px;
`;
